import { Component, Input, OnInit } from '@angular/core';
import { BaseComponent } from '@shared/components/base-component/base.component';
import { TabIndex } from '@shared/enums/tab-index.enum';
import { TabGroup } from '@shared/enums/tab-group.enum';
import { FormAction } from '@shared/enums/form.action.enum';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FilterService } from '@shared/services/filter.service';
import { takeUntil } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { SharedConstants } from '@shared/model/shared-constants';
import { ActivatedRoute } from '@angular/router';
import { RequestHistoryStatus } from '@shared/enums/request-history-status.enum';
import { RequestHistoryAction } from '@shared/enums/request-history-action.enum';
import { RequestCreatedByType } from '@shared-features/enums/request-created-by-type.enum';
import { ShipmentSearchFields } from '@features/transportation-payments/utils/transportaions.enums';
import { DateRangeType } from '@shared/enums';

@Component({
  selector: 'app-b2c-request-logs-filter',
  templateUrl: './b2c-request-logs-filter.component.html',
  styleUrls: ['./b2c-request-logs-filter.component.scss'],
})
export class B2cRequestLogsFilterComponent extends BaseComponent implements OnInit {
  @Input() action: Observable<void>;
  @Input() tabGroup: TabGroup;
  @Input() tabIndex: TabIndex;

  form: FormGroup;
  params: any = null;
  clearAllValues = {};
  requestHistoryStatus = RequestHistoryStatus;
  requestHistoryAction = RequestHistoryAction;
  requestCreatedByType = RequestCreatedByType;
  ShipmentSearchFields = ShipmentSearchFields;
  sharedConstants = SharedConstants;

  constructor(
    private filterService: FilterService,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder
  ) {
    super();
  }

  ngOnInit(): void {
    this.subscribeToQueryParams();
    this.subscribeToFilterAction();
    this.initForm();
  }

  subscribeToQueryParams(): void {
    this.activatedRoute.queryParams.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      if (params && Object.keys(params).length !== 0) {
        this.params = params;
      }
    });
  }

  getFilterValuesBasedOnURLParams() {
    return {
      status: this.params?.status ? this.params.status : SharedConstants.ALL,
      action: this.params?.action ? this.params.action : SharedConstants.ALL,
      from: this.params?.from ? this.params.from : SharedConstants.ALL,
      to: this.params?.to ? this.params.to : SharedConstants.ALL,
      requestUrl: this.params?.requestUrl ? this.params.requestUrl : '',
      dateRangeType: this.params?.dateRangeType ? this.params.dateRangeType : DateRangeType.TODAY,
      startFrom: this.params?.startFrom ? this.params.startFrom : '',
      endAt: this.params?.endAt ? this.params.endAt : '',
    };
  }

  initForm() {
    const filterValues = this.getFilterValuesBasedOnURLParams();
    this.form = this.fb.group({
      status: [filterValues.status],
      action: [filterValues.action],
      from: [filterValues.from],
      to: [filterValues.to],
      requestUrl: [filterValues.requestUrl],
      dateRangeType: [
        {
          range: filterValues.dateRangeType,
          startFrom: filterValues.startFrom,
          endAt: filterValues.endAt,
        },
      ],
    });
  }

  subscribeToFilterAction() {
    this.action.pipe(takeUntil(this.destroy$)).subscribe((action: any) => {
      switch (action) {
        case FormAction.Reset:
          this.resetForm();
          break;

        case FormAction.Cancel:
          this.cancelChanges();
          break;

        case FormAction.Submit:
          this.submitForm();
          break;
      }
    });
  }

  resetForm() {
    this.form.setValue({
      status: SharedConstants.ALL,
      action: SharedConstants.ALL,
      from: SharedConstants.ALL,
      to: SharedConstants.ALL,
      requestUrl: '',
      dateRangeType: {
        range: DateRangeType.TODAY,
        startFrom: '',
        endAt: '',
      },
    });
    this.submitForm();
  }

  cancelChanges() {
    if (this.params && Object.keys(this.params).length !== 0) {
      const filterValues = this.getFilterValuesBasedOnURLParams();
      this.form.setValue({
        status: filterValues.status,
        action: filterValues.action,
        from: filterValues.from,
        to: filterValues.to,
        requestUrl: filterValues.requestUrl,
        dateRangeType: {
          range: filterValues.dateRangeType,
          startFrom: filterValues.startFrom,
          endAt: filterValues.endAt,
        },
      });
    } else {
      this.resetForm();
    }
  }

  submitForm() {
    const { status, action, from, to, requestUrl, dateRangeType } = this.form.value;
    const submittedFilterValues = {
      status,
      action,
      from,
      to,
      requestUrl,
      dateRangeType: dateRangeType.range,
      startFrom: dateRangeType.startFrom,
      endAt: dateRangeType.endAt,
      tabGroup: TabGroup.B2CRequestLogs,
    };

    this.filterService.navigateToTargetPageWithFilter(submittedFilterValues);
  }
}
